import { getIsCashJourneySelected } from "@shared/v2/lib/getIsCashJourneySelected";
import { getPageVariant } from "@lib/getPageVariant";

export const getFinanceVariant = journey => {
  return getPageVariant(getIsCashJourneySelected(journey));
};
